export default __webpack_public_path__ + "static/media/bids4.29928c92.png";